import AdobeEventPageType from '~/constants/dealership/AdobeEventPageType';

export default function getAdobeEventPageType(): AdobeEventPageType {
  return window.location.pathname === '/'
    ? AdobeEventPageType.Home
    : window.location.pathname.startsWith('/cars')
    ? AdobeEventPageType.VehicleListing
    : window.location.pathname.startsWith('/service')
    ? AdobeEventPageType.Service
    : window.location.pathname.startsWith('/vehicle')
    ? AdobeEventPageType.VehicleDetails
    : AdobeEventPageType.Other;
}
